const topics = [
  { label: '院线新片', heat: '9.8w', active: true },
  { label: '国产剧', heat: '8.5w', active: true },
  { label: '韩剧', heat: '7.2w', active: false },
  { label: '美剧', heat: '6.9w', active: false },
  { label: '动漫', heat: '5.6w', active: false },
  { label: '综艺', heat: '4.8w', active: false },
  { label: '纪录片', heat: '3.3w', active: false },
  { label: '动作片', heat: '8.1w', active: true },
  { label: '悬疑剧', heat: '6.4w', active: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            热门话题
          </h2>
        </div>
        <div className="flex flex-wrap gap-2 md:gap-3">
          {topics.map((topic) => (
            <span
              key={topic.label}
              className={`whitespace-nowrap inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-all duration-200 ${
                topic.active
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
              }`}
            >
              {topic.label}
              <span className={`text-xs ${topic.active ? 'text-white/80' : 'text-foreground-400'}`}>
                {topic.heat}
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}